import { render } from "./leads-modal.vue?vue&type=template&id=153f62b4"
import script from "./leads-modal.vue?vue&type=script&lang=js"
export * from "./leads-modal.vue?vue&type=script&lang=js"

import "./leads-modal.vue?vue&type=style&index=0&id=153f62b4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__